import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Imageurldata from "../../../../Imageurldata";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../../../../component/InputText/InputText";

import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import config from "../../../../config/config";
import Ordering from "./Ordering";

const expinyearsOptions = [
  {
    name: "",
  },
  {
    name: "Months",
  },
  {
    name: "Years",
  },
];

const Products = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [exptabshow, setExptabshow] = useState(false);
  const [textline1, settextline1] = useState("");
  const [title, settitle] = useState("");
  const [category, setcategory] = useState("");
  const [unit, setunit] = useState("");
  const [categories, setcategories] = useState([]);
  const [oldLogoTitle, setoldLogoTitle] = useState("");
  const [newLogoTitle, setnewLogoTitle] = useState("");
  const [oldLogoDescription, setoldLogoDescription] = useState("");
  const [newLogoDescription, setnewLogoDescription] = useState("");
  const [textline1err, settextline1err] = useState("");
  const [units, setunits] = useState([]);
  const [subcategory, setsubcategory] = useState([]);
  const [link, setlink] = useState("");
  const [linkerr, setlinkErr] = useState("");
  const [selectedUnit, setselectedUnit] = useState("");
  const [selectedSubCategory, setselectedSubCategory] = useState("");
  const [bannerimg, setbannerimg] = useState("");
  const [bannerimgerr, setbannerimgErr] = useState("");
  const [bannerimgnotpresent, setbannerimgnotpresent] = useState("");
  const [selectedCategory, setselectedCategory] = useState("");
  const [mbbannerimg, setmbbannerimg] = useState("");
  const [mbbannerimgerr, setmbbannerimgErr] = useState("");
  const [mbImgNotPresent, setmbImgNotPresent] = useState("");
  const [description, setdescription] = useState("");
  const [order, setorder] = useState(0);
  const [type, settype] = useState("Add");
  const [updateModel, setUpdateModel] = useState(false);
  const [showMobImg, setShowMobImg] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState("");

  const [bannerid, setbannerid] = useState("");

  const [toastlist, setToastList] = useState([]);

  const [categoryErr, setCategoryErr] = useState("");
  const [unitErr, setUnitErr] = useState("");
  const [titleErr, setTitleErr] = useState("");
  const [descErr, setDescErr] = useState("");
  const [orderErr, setOrderErr] = useState("");
  let toastProperties = null;

  const [orderingModalOpen, setOrderingModalOpen] = useState(false);
  const [orderingCategories, setOrderingCategories] = useState([]);
  const [orderingSelectedCategory, setOrderingSelectedCategory] =
    useState(null);
  const [orderingProducts, setOrderingProducts] = useState([]);
  const [orderingLoading, setOrderingLoading] = useState(false);

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: `Product ${
            updateModel ? "updated" : "added"
          } Successfully`,
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "delete":
        toastProperties = {
          id,
          title: "Success",
          description: "Product deleted Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setUpdateModel(false);
    setShow(true);
    setShowMobImg(false);
    setShowDesktopImg(false);
    settype("Add");
    settitle("");
    setcategory("");
    setunit("");
    settextline1("");
    setoldLogoDescription("");
    setoldLogoTitle("");
    setnewLogoDescription("");
    setnewLogoTitle("");
    setlink("");
    setorder(0);
    setbannerimg("");
    setmbbannerimg("");
    setselectedUnit("units");
    setselectedSubCategory("subcategories");
    setselectedCategory("categories");
    setdescription("");
  };

  useEffect(() => {
    setLoading(true);

    axios({
      method: "get",
      url: urldata + "product/category",
      //withCredentials: true,
    })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        const temp = response.data;
        setcategories(temp);
        console.log(categories);
        //   const templist = response.data.reverse();
        //   setList(templist);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        //showToast("danger");
      });
    axios({
      method: "get",
      url: urldata + "product/products",
      //withCredentials: true,
    })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        const temp = response.data;
        //setcategories(temp);
        console.log(categories);
        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        //showToast("danger");
      });

    //showToast("danger");
  }, []);

  const handleShowForUpdate = (rowData) => {
    console.log(rowData);
    setUpdateModel(true);
    setShow(true);
    settype("Update");
    settextline1(rowData.text);
    settitle(rowData.title);
    //setcategory(rowData.category)
    setoldLogoDescription(rowData.oldLogoDescription);
    setdescription(rowData.description);
    setorder(rowData.order);
    setnewLogoDescription(rowData.newLogoDescription);
    setnewLogoTitle(rowData.newLogoTitle);
    setlink(rowData.buttonLink);
    // setmbbannerimg(Imageurldata + rowData.mobileImageUrl.replaceAll("\\","/"))
    setbannerimg(Imageurldata + rowData.desktopImageUrl.replaceAll("\\", "/"));
    // setmbImgNotPresent(rowData.mobileImageUrl.replaceAll("\\","/") ? false: true)
    setbannerimgnotpresent(
      rowData.desktopImageUrl.replaceAll("\\", "/") ? false : true
    );
    setselectedUnit(rowData.unit);
    setbannerid(rowData._id);
    setselectedCategory(rowData.category);
    setselectedSubCategory(rowData.subCategory);
    setShowMobImg(false);
    setShowDesktopImg(false);
    setbannerimgErr("");
    setCategoryErr("");
    setUnitErr("");
    setTitleErr("");
    setDescErr("");
    setOrderErr("");

    axios({
      method: "get",
      url: urldata + `product/subcategory?category=${rowData.category}`,
      //withCredentials: true,
    }).then((response) => {
      console.log(response);
      const tempsubcategorylist = response.data;
      setsubcategory(tempsubcategorylist);
      console.log(list);
      //setLoading(false);
    });
  };

  const updateBanner = () => {
    console.log("sub category", selectedSubCategory);
    var formData = new FormData();
    formData.append("category", selectedCategory);
    formData.append("unit", selectedUnit);
    formData.append("subCategory", selectedSubCategory);
    formData.append("order", order);
    formData.append("description", description);
    formData.append("title", title);
    if (mbImgNotPresent) {
      formData.append("mobileImageUrl", mbbannerimg);
      setmbImgNotPresent(false);
    }

    if (bannerimgnotpresent) {
      formData.append("desktopImageUrl", bannerimg);
      setbannerimgnotpresent(false);
    }

    let url = new URL(urldata + "admin/updateBannerImages");
    formData.append("id", bannerid);
    //url.searchParams.append('id', bannerid)
    var decoded = decodeURIComponent(url);

    axios({
      method: "post",
      url: urldata + "product/products/update",
      data: formData,
      //withCredentials: true,/banner/udpate
    })
      .then((response) => {
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        console.log("error--", error);
        setShow(false);
        // showToast("danger");
      });
  };

  const createbanner = () => {
    var formData = new FormData();
    formData.append("category", selectedCategory);
    formData.append("unit", selectedUnit);
    formData.append("subCategory", selectedSubCategory);
    formData.append("order", order);
    formData.append("description", description);
    formData.append("title", title);

    formData.append("buttonLink", link);
    formData.append("screen", "home");
    formData.append("mobileImageUrl", mbbannerimg);
    formData.append("desktopImageUrl", bannerimg);

    //formData.append("category", selectedCategory);
    let url = new URL(urldata + "admin/addBannerImages");

    axios({
      method: "post",
      url: urldata + "product/products/new",
      data: formData,
      // withCredentials: true,
    })
      .then((response) => {
        // settextline1("");
        // settextline2("");
        // settextline3("");
        // setlink("");
        // setbannerimg("");
        // setmbbannerimg("");
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        // showToast("danger");
      });
  };

  const submit = () => {
    var formIsValid = true;
    if (!bannerimg) {
      formIsValid = false;
      setbannerimgErr("*Please upload product image.");
    } else {
      setbannerimgErr("");
    }

    if (selectedUnit == "units") {
      formIsValid = false;
      setUnitErr("*Please select unit.");
    } else {
      setUnitErr("");
    }
    if (selectedCategory == "categories") {
      formIsValid = false;
      setCategoryErr("*Please select category.");
    } else {
      setCategoryErr("");
    }
    if (!title) {
      formIsValid = false;
      setTitleErr("*Please fill product name.");
    } else {
      setTitleErr("");
    }
    if (!description) {
      formIsValid = false;
      setDescErr("*Please fill description.");
    } else {
      setDescErr("");
    }
    // if (!order) {
    //   formIsValid = false;
    //   setOrderErr("*Please fill order no.");
    // } else {
    //   setOrderErr("");
    // }
    // if (!mbbannerimg) {
    //   formIsValid = false;
    //   setmbbannerimgErr("*Please upload mobile  banner image.");
    // } else {
    //   setmbbannerimgErr("");
    // }

    // <<<<<<< HEAD
    // if (bannerimg) {
    //   if (bannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setbannerimgErr("*File should be less than 300Kb.");
    //   }
    // }
    // if (mbbannerimg) {
    //   if (mbbannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setmbbannerimg("*File should be less than 300Kb.");
    //   }
    // }

    // =======
    // >>>>>>> vijay
    if (formIsValid) {
      if (updateModel) {
        updateBanner();
      } else {
        createbanner();
      }
    }
  };
  const selectCategory = (val) => {
    //val
    console.log(val);
    var formData = new FormData();
    formData.append("category", val);
    setselectedCategory(val);
    setselectedSubCategory("subcategories");
    setselectedUnit("units");
    console.log(typeof val);
    axios({
      method: "get",
      url: urldata + `product/unit?category=${encodeURIComponent(val)}`,
      //withCredentials: true,
    }).then((response) => {
      console.log(response);
      const templist = response.data;
      setunits(templist);
      console.log(list);
      //setLoading(false);
    });

    axios({
      method: "get",
      url: urldata + `product/subcategory?category=${encodeURIComponent(val)}`,
      //withCredentials: true,
    }).then((response) => {
      console.log(response);
      const tempsubcategorylist = response.data;
      setsubcategory(tempsubcategorylist);
      console.log(list);
      //setLoading(false);
    });
  };
  const selectUnit = (val) => {
    //val
    console.log(val);
    var formData = new FormData();
    formData.append("category", val);
    setselectedUnit(val);
    // console.log(typeof(val))
    // axios({
    //   method: "get",
    //   url: `https://api.laxmihos.com/api/product/unit?category=${val}`,
    //   //withCredentials: true,
    // })
    //   .then((response) => {
    //     console.log(response)
    //     const templist = response.data;
    //     setunits(templist);
    //     console.log(list)
    //     //setLoading(false);
    //   })
  };
  const selectSubCategory = (val) => {
    //val
    console.log(val);
    var formData = new FormData();
    formData.append("category", val);
    setselectedSubCategory(val);
    // console.log(typeof(val))
    // axios({
    //   method: "get",
    //   url: `https://api.laxmihos.com/api/product/unit?category=${val}`,
    //   //withCredentials: true,
    // })
    //   .then((response) => {
    //     console.log(response)
    //     const templist = response.data;
    //     setunits(templist);
    //     console.log(list)
    //     //setLoading(false);
    //   })
  };

  const deleteBtnClick = (id) => {
    setLoading(true);
    let data = {};
    data.id = id;

    let url = new URL(urldata + "admin/deleteBannerImage");

    axios({
      method: "post",
      url: urldata + "product/products/delete",
      data: data,
      // withCredentials: true,
    })
      .then((response) => {
        //   showToast("success");
        //   props.onHide(); props.history.push('/admin/login')

        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
        showToast("delete");
      })
      .catch((error) => {
        // showToast("danger");
        setLoading(false);
      });
  };

  // Fetch categories for ordering modal
  const fetchOrderingCategories = async () => {
    setOrderingLoading(true);
    try {
      const response = await axios.get(urldata + "product/category");
      setOrderingCategories(response.data);
    } catch (e) {
      setOrderingCategories([]);
    }
    setOrderingLoading(false);
  };

  // Fetch products by category for ordering modal
  const fetchOrderingProducts = async (categoryId) => {
    setOrderingLoading(true);
    try {
      const response = await axios.get(
        urldata + "product/byCategory/" + categoryId
      );
      setOrderingProducts(response.data);
    } catch (e) {
      setOrderingProducts([]);
    }
    setOrderingLoading(false);
  };

  const handleOpenOrderingModal = () => {
    console.log("inside ");
    setOrderingModalOpen(true);
    fetchOrderingCategories();
    setOrderingSelectedCategory(null);
    setOrderingProducts([]);
  };

  const handleCloseOrderingModal = () => {
    setOrderingModalOpen(false);
  };

  const handleOrderingCategoryChange = (e) => {
    const catId = e.target.value;
    setOrderingSelectedCategory(catId);
    if (catId) {
      fetchOrderingProducts(catId);
    } else {
      setOrderingProducts([]);
    }
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div
        className="addjobinlist text-right mb-4"
        style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
      >
        <Button title="Add Product" onClick={handleShow} />
        <Button title="View Ordering" onClick={handleOpenOrderingModal} />
      </div>
      <MaterialTable
        title="Products List"
        columns={[
          { title: "Product Category", field: "category" },
          { title: "Product Sub Category", field: "subCategory" },
          { title: "Product name", field: "title" },
          { title: "Product Unit", field: "unit" },
          // { title: "Order", field: "order" },
          { title: "Product Description", field: "description" },
          // {
          //   field: "url",

          //   title: "Mobile Image  ",
          //   render: (rowData) => (
          //     <div className="d-f">
          //       <Button
          //         title="View"
          //         onClick={() => {
          //           window.open(
          //             Imageurldata +
          //               rowData.mobileImageUrl.replaceAll("\\", "/"),
          //             "_blank"
          //           );
          //         }}
          //       ></Button>
          //     </div>
          //   ),
          // },
          {
            field: "url",

            title: "Image  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title="View"
                  onClick={() => {
                    window.open(
                      Imageurldata +
                        rowData.desktopImageUrl.replaceAll("\\", "/"),
                      "_blank"
                    );
                  }}
                ></Button>
              </div>
            ),
          },
          {
            field: "url",

            title: "Action  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title=" Update"
                  onClick={() => {
                    handleShowForUpdate(rowData);
                  }}
                ></Button>
                <Button
                  title=" Delete"
                  onClick={() => deleteBtnClick(rowData._id)}
                ></Button>
              </div>
            ),
          },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />

      <Modal
        {...props}
        //   size="lg"
        //   aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="addbannerModel"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="model">
          <div className="title">{type} product</div>

          <Row>
            <Col lg={3} className="column">
              <div className="titleitem">{type} category </div>
            </Col>
            <Col lg={9} className="column">
              <DropdownButton
                id="dropdown-basic-button"
                onSelect={(e) => selectCategory(e)}
                title={selectedCategory}
              >
                {categories.map((cat, index) => {
                  //console.log(cat)
                  return (
                    <Dropdown.Item
                      value={cat.title}
                      eventKey={cat.title}
                      key={index}
                    >
                      {cat.title}
                    </Dropdown.Item>
                  );
                })}

                {/* <div className="count">{textline1.length}/31</div> */}
              </DropdownButton>
              <div className="err">{categoryErr}</div>
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} unit </div>
            </Col>
            <Col lg={9} className="column">
              <DropdownButton
                id="dropdown-basic-button"
                onSelect={(e) => selectUnit(e)}
                title={selectedUnit}
              >
                {units.map((unit, index) => {
                  //console.log(cat)
                  return (
                    <Dropdown.Item
                      value={unit.title}
                      eventKey={unit.title}
                      key={index}
                    >
                      {unit.title}
                    </Dropdown.Item>
                  );
                })}

                {/* <div className="count">{textline1.length}/31</div> */}
              </DropdownButton>
              <div className="err">{unitErr}</div>
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} Sub Category </div>
            </Col>
            <Col lg={9} className="column">
              <DropdownButton
                id="dropdown-basic-button"
                onSelect={(e) => selectSubCategory(e)}
                title={
                  selectedSubCategory ? selectedSubCategory : "No Subcategory"
                }
              >
                {subcategory.map((unit, index) => {
                  //console.log(cat)
                  return (
                    <Dropdown.Item
                      value={unit.title}
                      eventKey={unit.title}
                      key={index}
                    >
                      {unit.title}
                    </Dropdown.Item>
                  );
                })}

                {/* <div className="count">{textline1.length}/31</div> */}
              </DropdownButton>
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} name </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={title}
                onChange={(e) => settitle(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{titleErr}</div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} description </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={description}
                onChange={(e) => setdescription(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{descErr} </div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            {/* <Col lg={3} className="column">
              <div className="titleitem">{type} order </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={order}
                onChange={(e) => setorder(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{orderErr} </div>

              <div className="count">{textline1.length}/31</div>
            </Col> */}

            <Col lg={3} className="column">
              <div className="titleitem">{type} Image</div>
              <div className="desc">Size :- 194 × 242 px</div>
            </Col>
            <Col lg={9} className="column">
              <input
                id="bannerImage"
                accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG"
                type="file"
                onChange={(e) => {
                  setbannerimg(e.target.files[0]);
                  setShowDesktopImg(true);
                  setbannerimgnotpresent(true);
                }}
                name="passport_proof_upload"
              />

              <label for="bannerImage" className="d-f" id="file-drag">
                <img src={upload} class="img-fluid" />
                <div class="chooseTxt">Choose File</div>
              </label>

              <div className="d-f jc-sb">
                <div className="fileTxt">File Format : JPG / PNG</div>
              </div>
              <div className="err">{bannerimgerr} </div>

              <div>
                {bannerimg !== "" && (
                  <img
                    src={
                      showDesktopImg
                        ? URL.createObjectURL(bannerimg)
                        : bannerimg
                    }
                    className="img-fluid"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}
              </div>
            </Col>

            {/* <Col lg={3} className="column">
              <div className="titleitem">Add Mobile Image</div>
              <div className="desc">Size :- 640 × 630</div>
            </Col>
            <Col lg={9} className="column">
              <input
                id="bannerImage1"
                accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG "
                type="file"
                onChange={(e) => {
                  setmbbannerimg(e.target.files[0]);
                  setShowMobImg(true);
                  setmbImgNotPresent(true);
                }}
                name="passport_proof_upload"
              />

              <label for="bannerImage1" className="d-f" id="file-drag">
                <img src={upload} class="img-fluid" />
                <div class="chooseTxt">Choose File</div>
              </label>

              <div className="d-f jc-sb">
                <div className="fileTxt">File Format : JPG / PNG</div>
              </div>
              <div className="err">{mbbannerimgerr} </div>

              <div>
                {mbbannerimg !== "" && (
                  <img
                    src={
                      showMobImg
                        ? URL.createObjectURL(mbbannerimg)
                        : mbbannerimg
                    }
                    className="img-fluid"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}
              </div>
            </Col> */}
          </Row>
          <div className="btnContainer mt-4">
            <Button onClick={submit} title="SUBMIT" />
          </div>
        </Modal.Body>
      </Modal>
      <Toast toastList={toastlist} position="top-right" />
      {/* Ordering Modal */}
      <Ordering
        isOpen={orderingModalOpen}
        onClose={handleCloseOrderingModal}
        categories={categories}
        moduleName="Products"
        isMobile={false}
        image_url={Imageurldata}
        base_url={urldata + "product"}
      />
    </>
  );
};

export default Products;

// updateBannerImages
